export default __webpack_public_path__ + "static/char-v-sp02-4cb56dcce8ed6496d3a7ad5df64b5c03.webp";